var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGuidelines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7351_74235)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#007BC1"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7351_74235)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H70.8333H100H129.167H200V70.8333V100V129.167V200H129.167H100H70.8333H0V129.167V100V70.8333V0ZM70.8333 70.8333C63.3694 78.298 58.75 88.6099 58.75 100C58.75 111.39 63.3694 121.702 70.8333 129.167C78.298 136.631 88.6099 141.25 100 141.25C111.39 141.25 121.702 136.631 129.167 129.167C136.631 121.702 141.25 111.39 141.25 100C141.25 88.6099 136.631 78.298 129.167 70.8333C121.702 63.3694 111.39 58.75 100 58.75C88.6099 58.75 78.298 63.3694 70.8333 70.8333Z",
    fill: "#007BC1",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8333 100H58.75C58.75 111.39 63.3694 121.702 70.8333 129.167V100Z",
    fill: "#007BC1",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.75 100H70.8333V70.8333C63.3694 78.298 58.75 88.6099 58.75 100Z",
    fill: "#007BC1",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 100L70.8333 70.8333V100H100Z",
    fill: "#007BC1",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 70.8333H70.8333L100 100V70.8333Z",
    fill: "#007BC1",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8333 70.8333H100L100 58.75C88.6099 58.75 78.298 63.3694 70.8333 70.8333Z",
    fill: "#007BC1",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 70.8333H129.167C121.702 63.3694 111.39 58.75 100 58.75L100 70.8333Z",
    fill: "#007BC1",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.167 70.8333H100V100L129.167 70.8333Z",
    fill: "#007BC1",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.167 70.8333L100 100H129.167V70.8333Z",
    fill: "#007BC1",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.167 100H141.25C141.25 88.6099 136.631 78.298 129.167 70.8333V100Z",
    fill: "#007BC1",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.25 100H129.167V129.167C136.631 121.702 141.25 111.39 141.25 100Z",
    fill: "#007BC1",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 100L129.167 129.167V100H100Z",
    fill: "#007BC1",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.167 129.167L100 100V129.167H129.167Z",
    fill: "#007BC1",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 100L70.8333 129.167H100V100Z",
    fill: "#007BC1",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8333 129.167L100 100H70.8333V129.167Z",
    fill: "#007BC1",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 141.25L100 129.167H70.8333C78.298 136.631 88.6099 141.25 100 141.25Z",
    fill: "#007BC1",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 129.167L100 141.25C111.39 141.25 121.702 136.631 129.167 129.167H100Z",
    fill: "#007BC1",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8333 0H0M70.8333 0H100M70.8333 0V70.8333M0 0V70.8333M0 0L70.8333 70.8333M70.8333 70.8333H100M70.8333 70.8333L100 100M70.8333 70.8333V100M70.8333 70.8333C63.3694 78.298 58.75 88.6099 58.75 100M70.8333 70.8333H0M70.8333 70.8333C78.298 63.3694 88.6099 58.75 100 58.75M70.8333 70.8333C70.8343 70.8323 70.8323 70.8343 70.8333 70.8333ZM200 0H129.167M200 0V70.8333M200 0L129.167 70.8333M129.167 0H100M129.167 0V70.8333M129.167 70.8333H100M129.167 70.8333L100 100M129.167 70.8333V100M129.167 70.8333C121.702 63.3694 111.39 58.75 100 58.75M129.167 70.8333C136.631 78.298 141.25 88.6099 141.25 100M129.167 70.8333C129.168 70.8343 129.166 70.8323 129.167 70.8333ZM129.167 70.8333H200M200 70.8333V100M0 70.8333V100M100 70.8333V0M100 70.8333V100M100 70.8333L100 58.75M0 129.167V200M0 129.167V100M0 129.167H70.8333M0 200H70.8333M0 200L70.8333 129.167M70.8333 129.167L100 100M70.8333 129.167V100M70.8333 129.167H100M70.8333 129.167C63.3694 121.702 58.75 111.39 58.75 100M70.8333 129.167C78.298 136.631 88.6099 141.25 100 141.25M70.8333 129.167C70.8323 129.166 70.8343 129.168 70.8333 129.167ZM70.8333 129.167V200M129.167 129.167L100 100M129.167 129.167V100M129.167 129.167H100M129.167 129.167C136.631 121.702 141.25 111.39 141.25 100M129.167 129.167H200M129.167 129.167C121.702 136.631 111.39 141.25 100 141.25M129.167 129.167C129.166 129.168 129.168 129.166 129.167 129.167ZM129.167 129.167V200M129.167 129.167L200 200M200 200V129.167M200 200H129.167M200 129.167V100M200 100H129.167M129.167 100H100M129.167 100H141.25M100 100V129.167M100 100H70.8333M0 100H70.8333M70.8333 100H58.75M100 129.167V200M100 129.167L100 141.25M100 200H70.8333M100 200H129.167",
    stroke: "#268FCA",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.8335,
    y: 17.1667,
    width: 132.333,
    height: 165.667,
    rx: 1.5,
    stroke: "#4DA3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.1665,
    y: 33.8333,
    width: 165.667,
    height: 132.333,
    rx: 1.5,
    stroke: "#4DA3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 25.5,
    width: 149,
    height: 149,
    rx: 1.5,
    stroke: "#4DA3D4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.9998,
    cy: 100,
    r: 82.8333,
    stroke: "#4DA3D4"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.546 35.6084C150 36.4997 150 37.6665 150 40V50H166.667C175.917 50 183.25 57.4167 183.25 66.6667L183.333 150C183.333 159.25 175.917 166.667 166.667 166.667H33.3332C24.0832 166.667 16.6665 159.25 16.6665 150V66.6667C16.6665 57.4167 24.0832 50 33.3332 50H49.9998V40C49.9998 37.6665 49.9998 36.4997 50.454 35.6084C50.8535 34.8244 51.4909 34.187 52.2749 33.7875C53.1662 33.3333 54.333 33.3333 56.6665 33.3333H76.6665C79.0001 33.3333 80.1668 33.3333 81.0581 33.7875C81.8422 34.187 82.4796 34.8244 82.879 35.6084C83.3332 36.4997 83.3332 37.6665 83.3332 40V50H116.667V40C116.667 37.6665 116.667 36.4997 117.121 35.6084C117.52 34.8244 118.158 34.187 118.942 33.7875C119.833 33.3333 121 33.3333 123.333 33.3333H143.333C145.667 33.3333 146.834 33.3333 147.725 33.7875C148.509 34.187 149.146 34.8244 149.546 35.6084ZM116.667 100H150V116.667H116.667V100ZM58.3332 100H45.8332V116.667H58.3332V129.167H74.9998V116.667H87.4998V100H74.9998V87.5H58.3332V100Z",
    fill: "white",
    fillOpacity: 0.3,
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7351_74235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7351_74235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGuidelines);
export default __webpack_public_path__ + "static/media/icon-guidelines.038ab201ecfb18c0a4246c5d9e6a0237.svg";
export { ForwardRef as ReactComponent };